<template>
  <table class="table" :id="dataTable.id">
    <thead>
      <tr>
        <th>Nome</th>
        <th class="text-center">Cursos Não Iniciados</th>
        <th class="text-center">Cursos Em Andamento</th>
        <th class="text-center">Cursos Concluídos</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="user in usersProgress" :key="user.id">
        <td>
          <router-link :to="`/users/${user.id}`" title="Detalhes do Usuário">
            {{ user.name }}
          </router-link>
        </td>
        <td
          class="text-center tooltip-courses cursor-pointer"
          @mouseover="$emit('getCoursesUser', user.id)"
        >
          <span
            v-if="user.courses && user.courses.notStarted"
            class="tooltip-text"
            v-html="user.courses.notStarted"
          />
          {{ user.notStarted }}
        </td>
        <td
          class="text-center tooltip-courses cursor-pointer"
          @mouseover="$emit('getCoursesUser', user.id)"
        >
          <span
            v-if="user.courses && user.courses.inProgress"
            class="tooltip-text"
            v-html="user.courses.inProgress"
          />
          {{ user.inProgress }}
        </td>
        <td
          class="text-center tooltip-courses cursor-pointer"
          @mouseover="$emit('getCoursesUser', user.id)"
        >
          <span
            v-if="user.courses && user.courses.done"
            class="tooltip-text"
            v-html="user.courses.done"
          />
          {{ user.done }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import '@/utils/basicDataTableExtend'
import { statusTranslate } from '@/utils/strings'

export default {
  name: 'ListUsersProgress',

  props: {
    usersProgress: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      dataTable: {
        id: 'dataTableListUsersProgress',
      },
      statusTranslate,
    }
  },

  methods: {
    createDataTable() {
      window.$(`#${this.dataTable.id}`).DataTable()
    },
  },

  mounted() {
    this.createDataTable()
  },
}
</script>

<style scoped>
.tooltip-courses {
  position: relative;
}

.tooltip-courses .tooltip-text {
  visibility: hidden;
  width: 300px;
  background-color: #252b36;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px;
  position: absolute;
  z-index: 1;
  bottom: 100%;
  left: 21%;
  margin-left: -60px;
}

.tooltip-courses .tooltip-text::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #252b36 transparent transparent transparent;
}

.tooltip-courses:hover .tooltip-text {
  visibility: visible;
}
</style>
